import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/TeacherProfilePage.css';
import { useNavigate } from 'react-router-dom';

const TeacherProfilePage = ({isSidebarCollapsed}) => {
    const { teacherId } = useParams(); 
    const [teacher, setTeacher] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTeacherDetails = async () => {
            try {
                const response = await api.get(`/teacher/profile/${teacherId}`);
                setTeacher(response.data?.data[0] || null);
            } catch (error) {
                console.error("Failed to fetch teacher details", error);
            }
        };
        fetchTeacherDetails();
    }, [teacherId]);

    if (!teacher) return <p>Loading teacher details...</p>;

    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
            <div className="page-title">Teacher profile</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Teacher Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>:</td>
                                <td>{teacher.teacher_name}</td>
                            </tr>
                            <tr>
                                <td>NIK</td>
                                <td>:</td>
                                <td>{teacher.teacher_code}</td>
                            </tr>
                            <tr>
                                <td>Branch</td>
                                <td>:</td>
                                <td>{teacher.Branch ? teacher.Branch.branch_name : "Central"}</td>
                            </tr>
                            <tr>
                                <td>Birth Date</td>
                                <td>:</td>
                                <td>{moment(teacher.birth_date).format('DD MMMM YYYY')}</td>
                            </tr>
                            <tr>
                                <td>Phone Number</td>
                                <td>:</td>
                                <td>{teacher.phone_number}</td>
                            </tr>
                            <tr>
                                <td>Address</td>
                                <td>:</td>
                                <td>{teacher.address}</td>
                            </tr>
                            <tr>
                                <td>Salary</td>
                                <td>:</td>
                                <td>{formatCurrency(teacher.salary)}</td>
                            </tr>
                            <tr>
                                <td>Join Date</td>
                                <td>:</td>
                                <td>{moment(teacher.join_date).format('DD MMMM YYYY')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="section">
                    <h3 className="section-header">Emergency Contact Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>:</td>
                                <td>{teacher.emergency_contact_person ? teacher.emergency_contact_person : '-'}</td>
                            </tr>
                            <tr>
                                <td>Phone Number</td>
                                <td>:</td>
                                <td>{teacher.emergency_phone_number ? teacher.emergency_phone_number : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="button-group-profile">
                    <button className="profile-button" onClick={() => navigate(`/teacher/edit/${teacher.teacher_id}`)}>Edit</button>
                    <button className="profile-button" onClick={() => navigate('/teacher/list')}>Back</button>
                </div>
            </div>
        </div>
    );
};

export default TeacherProfilePage;
